module.exports = __webpack_public_path__ + "static/media/vert.721a4df5.png";